import { CommonDialogs } from "@mcleod/common";
import { Button, ClickEvent, Snackbar, Table } from "@mcleod/components";
import { Keys, MapSettings, StringUtil } from "@mcleod/core";
import { AutogenLayoutGooglePlaces } from "./autogen/AutogenLayoutGooglePlaces";

export class GooglePlaces extends AutogenLayoutGooglePlaces {

    override onLoad() {
        const googleApiKey = MapSettings.get()?.google_api_key;
        const hasApiKey = !StringUtil.isEmptyString(googleApiKey);
        this.panelWarning.visible = !hasApiKey;
        this.panelSearchGoogle.visible = hasApiKey;
        this.textboxGoogleSearch.addHandlerForKey(Keys.ENTER, { ctrlKey: true }, () => this.buttonSearch.clicked());
        this.textboxGoogleSearch.addHandlerForKey(Keys.ENTER, {}, () => this.buttonSearch.clicked());
    }

    async buttonSearchOnClick(event?: ClickEvent) {
        const searchButton = event.target as Button;
        const lmSearch = this.textboxGoogleSearch.text;
        const tableGooglePlaceSearch: Table = this.tableGooglePlaceSearch;
        if (StringUtil.isEmptyString(lmSearch)) {
            Snackbar.showWarningSnackbar("Please type a place name or address before searching.");
            tableGooglePlaceSearch.clearRows();
            return;
        }
        searchButton.busy = true;
        try {
            await tableGooglePlaceSearch.dataSource.search({"lm_search": lmSearch })
        } catch (error) {
            CommonDialogs.showError(error);
        } finally {
            searchButton.busy = false;
        }
    }

}
